import React, { useRef, useEffect } from 'react';
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const AddInventoryForm = ({
    file,
    setFile,
    validated, 
    handleSubmit,
    locationsUploading
    }) => {
    const inputRef = useRef(null);

    useEffect(() => {
        const focus = () => {
            if (inputRef.current) {
                inputRef.current.focus();
            }
        }
        setTimeout(focus, 100);
    }, []);

    return (
        <Container fluid>
            <div className="w-100 h-100 p-4 pt-3 border customFormBox">
                <Form
                    className="h-100"
                    validated={validated}
                    onSubmit={handleSubmit}
                >
                    <Row>
                        <Col>
                            <Form.Label>
                                Subir archivo para agregar inventario
                            </Form.Label>
                        </Col>
                    </Row>
                    <Row>
                        <Form.Group as={Col} sm={10}>
                            <Form.Control
                                required
                                autoFocus
                                ref={inputRef}
                                name="inventoryFile"
                                type="file"
                                placeholder="Inventario por ubicación.txt"
                                accept=".txt,.csv"
                                onChange={(event) => setFile(event.currentTarget)}
                            />
                        </Form.Group>
                        <Col sm={2}>
                            <Button 
                                className="w-100" 
                                type="submit" 
                                variant="primary"
                                disabled={!file || locationsUploading}
                            >
                                Subir
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        </Container>
    );
}
 
export default AddInventoryForm;